import { render, staticRenderFns } from "./MyPreferencesCard.vue?vue&type=template&id=57bd5f26&scoped=true&"
import script from "./MyPreferencesCard.vue?vue&type=script&lang=ts&"
export * from "./MyPreferencesCard.vue?vue&type=script&lang=ts&"
import style0 from "./MyPreferencesCard.vue?vue&type=style&index=0&id=57bd5f26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd5f26",
  null
  
)

export default component.exports